import { whenGt } from '@execonline-inc/numbers';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';

interface Props {
  duplicateProgramDeepLinkCount: number;
}

function Skeleton({ duplicateProgramDeepLinkCount }: Props) {
  return (
    <>
      {just(duplicateProgramDeepLinkCount)
        .andThen(whenGt(0))
        .map(() => (
          <div className="mr-4 w-1/3">
            <div className="h-5 w-12 bg-gray-300 rounded mb-2"></div>
            <div className="h-8 bg-gray-300 rounded"></div>
          </div>
        ))
        .getOrElse(() => (
          <></>
        ))}
      <div className="mr-4 w-1/3">
        <div className="h-5 w-12 bg-gray-300 rounded mb-2"></div>
        <div className="h-8 bg-gray-300 rounded"></div>
      </div>
    </>
  );
}

export default observer(Skeleton);
